import PropTypes from 'prop-types'

import { Box, Button, Container, Icon } from '@redriverpress/system'

import MaterialsRow from './MaterialsRow'

export default function CourseMaterials({ contents, onAddCourseToClass }) {
  return (
    <Box bg='gray50' py={4}>
      <Container
        display='flex'
        flexDirection='column'
        justifyContent='flex-start'
      >
        {contents.map(content => (
          <MaterialsRow key={content.position} content={content} />
        ))}

        <Button
          alignSelf='center'
          mt={3}
          onClick={onAddCourseToClass}
          width='fit-content'
          adaptive
        >
          <Icon icon='plus' pr={2} />
          Add to class
        </Button>
      </Container>
    </Box>
  )
}

CourseMaterials.propTypes = {
  contents: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      type: PropTypes.string.isRequired,
      position: PropTypes.number.isRequired,
      content: PropTypes.shape({
        id: PropTypes.number.isRequired,
        type: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        path: PropTypes.string.isRequired,
        image: PropTypes.string,
        thumbnail_url: PropTypes.string,
      }),
    })
  ).isRequired,
  onAddCourseToClass: PropTypes.func.isRequired,
}
